export default __webpack_public_path__ + "static/media/conference.60af5058.svg";